import React, {FC, useEffect, useState} from "react"

import Loading from "@irati/ui/src/Loading"
import HomepageLanesQuery from "@irati/homepage/apollo/query/HomepageLanesQuery"
import {HomepageKind, HomepageLane, HomepageLaneType, PaymentCurrencyType, WalletEntityType} from "@irati/types"
import isRPDeal from "@irati/deals/helpers/deals/isRPDeal"
import {getLaneHeader} from "@irati/homepage/helpers"
import FeedSlider from "@irati-web/perks/src/components/FeedSlider"
import walletService from "@irati/wallet/graph/wallet"
import authentication from "@irati/auth"
import DealPages from "@irati-web/perks/src/enums/DealPages"
import HomepageLaneTypesForSlider from "@irati/deals/constants/sliderHomepageLaneTypes"

import CelebrationBanner from "./CelebrationBanner"

const Lanes: FC = () => {
  const [rpBalance, setRpBalance] = useState<number>(0)
  const [load, setLoad] = useState<Promise<void>>()

  useEffect(() => {
    const promise = walletService
      .get(authentication.user().uuid!, PaymentCurrencyType.Rp, WalletEntityType.User)
      .then((data) => setRpBalance(data.availableBalance))
    setLoad(promise)
  }, [])

  return (
    <Loading load={load}>
      <HomepageLanesQuery variables={{kind: HomepageKind.KindPlatform}}>
        {({data}) => {
          const lanes: HomepageLane[] = data?.homepageLanes?.results || []
          if (!lanes.length) return null
          return lanes.map(({type, bodyText, deals, headerText, tag, seeMoreUrl}, i) => {
            if (type === HomepageLaneType.Recognition) {
              return <CelebrationBanner key={`lane${i}`} />
            }
            if (authentication.apps("perks")) {
              if (HomepageLaneTypesForSlider.includes(type)) {
                // Hide any reward lane if user RP balance is 0
                if (isRPDeal(deals[0]) && !rpBalance) {
                  return null
                }

                const laneHeaderText = getLaneHeader(type, tag, headerText)
                return (
                  <FeedSlider
                    data={deals}
                    sectionHeaderText={laneHeaderText}
                    showSectionHeader={!!laneHeaderText}
                    seeMoreUrl={seeMoreUrl}
                    sectionBodyText={bodyText}
                    key={`lane${i}`}
                    page={DealPages.PLATFORM_HOMEPAGE}
                  />
                )
              }
            }

            return null
          })
        }}
      </HomepageLanesQuery>
    </Loading>
  )
}

export default Lanes
